export default __webpack_public_path__ + "static/media/Krishna.71bf005f.jpeg";